import * as React from 'react';

import { reduceStyles } from '@/helpers';
import styles from './style';
import type { TextProps } from './model';

const WBText: React.FC<TextProps> = ({ color, children, numberOfLines, style, ...props }) => {
	const styleObject = reduceStyles([
		styles.text,
		color && { color },
		numberOfLines && numberOfLines > 0
			? {
					...styles.textMultiLine,
					WebkitLineClamp: numberOfLines,
			  }
			: styles.textOneLine,
		style,
	] as object);

	return (
		<span {...props} style={styleObject}>
			{children}
		</span>
	);
};

export default WBText;
